/**
 * Create one HTTP error value.
 */
export function httpError(message, status, descriptor, body) {
    return {
        kind: "http",
        message,
        status,
        descriptor,
        ...(body == null ? {} : { body }),
    };
}
/**
 * Create one availability error value.
 */
export function availabilityError(message, status, descriptor, availabilityKind, body) {
    return {
        kind: "availability",
        message,
        status,
        descriptor,
        availabilityKind,
        ...(body == null ? {} : { body }),
    };
}
/**
 * Create one contract error value.
 */
export function contractError(path, message) {
    return {
        kind: "contract",
        message,
        path,
    };
}
/**
 * Create one network error value.
 */
export function networkError(message, cause) {
    return {
        kind: "network",
        message,
        ...(cause === undefined ? {} : { cause }),
    };
}
//# sourceMappingURL=errors.js.map